import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { format } from "date-fns";
import { Big3DatePicker, NoResult, GoodsPhoto, Alert } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:도매별 문의 리스트
 * 세부설명:
*/

export class WhQuestList extends Component {
    static displayName = WhQuestList.name;

    constructor(props) {
        super(props);
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -29), "yyyy-MM-dd");
        this.toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");
        this.SelectMonth = 1;
        this.state = {
            WQstDtList: [],
            FromDate: this.fromDate,
            ToDate: this.toDate,
            SelectMonth: this.SelectMonth,
            Content:""
        };

        this.CsName = Big3Common.ContentState;
        this.Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Uid, null);
        this.handleConverInfo_Click = this.handleConverInfo_Click.bind(this);
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleMonth_Click = this.handleMonth_Click.bind(this);

    }
    //초기화
    componentDidMount() {
        this.CallQstMgtDtlListData();
    }
    //주문문의 조회
    async CallQstMgtDtlListData() {
        try {

            Big3Common.Util.LoadingOn();
            let Paging = {
                Uid: this.Uid,
                FromDate: this.state.FromDate,
                ToDate: this.state.ToDate
            }
          
            let Data = await Big3Common.Post('api/Chat/ChatList/GetQstMgtDtlList', Paging, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let NowWQstDtList = JSON.parse(Data.dataTable);
                this.setState({ WQstDtList: NowWQstDtList });
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning){
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtDtlListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //대화목록 이동
    handleConverInfo_Click(event, list) {
       
        const whole_name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Whole_Name, "");
        this.props.RenderComponent('ConverInfo',
            {
                [this.CsName.Uid]: list.uid,
                [this.CsName.Whole_Name]: whole_name,
                [this.CsName.QstgrpNo]: list.qstgrp_no
            });
        event.preventDefault();
    }
    //월별 버튼 클릭
    handleMonth_Click(event, Month) {
        let fromDate = format(Big3Common.Util.DateAdd(new Date(this.state.ToDate), -(Month * 30)), "yyyy-MM-dd");
        this.setState({ SelectMonth: Month, FromDate: fromDate });
        event.preventDefault();
    }
    //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
    }
    WholeOrderrender() {
        const WQstDtList = this.state.WQstDtList;
        return ( 
            <>
                {
                    WQstDtList.map(list =>
                        <div className="alert_content no_title alert_content" key={list.qstgrp_no}
                            onClick={(e) => { this.handleConverInfo_Click(e, list); } }
                        >
                            <div className="alert_img">
                                <GoodsPhoto className="alert_img_in"
                                    ImageSrc={list.img_220}
                                />
                            </div>
                            <div className="alert_txt">
                                <div className="shop_name2">
                                    <div>{list.reg_dt }</div>
                                    <div className={list.conf_yn === "N" ? "alert_new" : "item_hide"}></div>
                                </div>
                                <div className="shop_name">문의번호 : {list.qstgrp_no} </div>
                                <div className="alert_detail_v2">{list.goods_names || "" }</div>
                                <div className="alert_detail_v2">금액: {list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price) }원`}</div>
                                <div className="order_btn or_btn5">{list.qstmgt_status_nm}</div>
                                <div className="c_icon_box">
                                    {list.conf_count > 0 ? <div className="Q_icon"></div> : ""}
                                    {list.comment_count > 0 ? <div className="C_icon"></div> : ""}
                                </div>
                            </div>
                        </div>
                    )
                }
            </>
        )
    }
    render() {
        const WholeOrderrender = this.WholeOrderrender();
        return (
            <div className="p_b_margin d_padding container_box">
                <div className="search_box_v4">
                    <div className="select_month_box">
                        <div className={this.state.SelectMonth === 1 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 1) }}>1개월</div>
                        <div className={this.state.SelectMonth === 3 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 3) }}>3개월</div>
                        <div className={this.state.SelectMonth === 6 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 6) }}>6개월</div>
                    </div>
                    <div className="select_date_box">
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.FromDate)}
                                DateChange={this.handleCalendarChange}
                                id="FromDate"
                            />
                        </div>
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.ToDate)}
                                DateChange={this.handleCalendarChange}
                                id="ToDate"
                            />
                        </div>
                        <button type="button" className="date_s_btn" onClick={() => { this.CallQstMgtDtlListData() }}>조회</button>
                    </div>
                </div>
                {WholeOrderrender}
                <NoResult
                    
                    Text="검색결과가 없습니다."
                    Visible={this.state.WQstDtList.length === 0 ? true : false}
                    Top={"50%"}
                />
                <Alert
                    title="검색안내"
                    id="MessageAlert"
                    content={this.state.Content}
                />
            </div>
        );
    }
}
